<i18n>
{
    "et": {
        "Timezone": "Ajatsoon",
        "Load more timezones": "Lae rohkem ajatsoone"
    }
}
</i18n>
<template>
  <div>
    <v-autocomplete
      v-model="selected"
      :filter="filter"
      :items="timezones"
      v-bind="$attrs"
      :loading="loading"
      @click="autoFetch ? (search = true) : null"
    >
      <template #label v-if="label">
        <span v-t="label" />
      </template>
      <template #append-item>
        <v-list-item v-if="loading">
          <v-list-item-content class="d-flex">
            <v-progress-circular indeterminate color="info"></v-progress-circular>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else-if="!fetched" @click="search = true">
          <v-list-item-content>
            <v-list-item-title>
              <em>
                {{ "Load more timezones" }}
              </em>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
const defaultTimezones = ["Europe/Tallinn"];

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    defaultTimezones: {
      type: Array,
      default: defaultTimezones,
    },
    label: {
      type: String,
      default: "Timezone",
    },
    autoFetch: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selected: this.value
        ? this.value
        : this.defaultTimezones && this.defaultTimezones[0]
        ? this.defaultTimezones[0]
        : null,
      timezones: this.defaultTimezones,
      loading: false,
      search: null,
      fetched: null,
    };
  },

  created() {
    if (!this.computedSelectedTimezone) {
      this.search = true;
    }
  },

  watch: {
    search(val) {
      if (this.fetched || this.loading) return;
      this.loading = true;
      this.fetchTimezones();
    },

    selected: {
      immediate: true,
      handler(selected) {
        this.$emit("input", selected);
      },
    },
  },

  computed: {
    computedSelectedTimezone() {
      return this.timezones.find((item) => item === this.selected);
    },
  },

  methods: {
    filter(item, queryText, itemText) {
      const text = item.toLowerCase();
      const searchText = queryText.toLowerCase();

      return text.indexOf(searchText) > -1;
    },
    async fetchTimezones() {
      this.loading = true;
      try {
        const response = await this.axios({
          method: "get",
          url: "api/timezones",
          baseURL: "/",
        });

        this.timezones = response.data;
        this.fetched = true;
      } catch (error) {
        // console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
